import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { TaxItemApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	summaryTaxes: TaxItemApi[];
}

const OrderFormItemsSummaryTableBody = ({ summaryTaxes }: Props) => {
	const { t } = useTranslation();
	const organization = useSelector(selectOrganization);
	const currency = organization.currency || "";

	const taxesSummary = summaryTaxes.reduce(
		(acc, val) => acc + (val.price_tax?.amount ? val.price_tax?.amount : 0),
		0
	);

	const grossSummary = summaryTaxes.reduce(
		(acc, val) => acc + (val.price_gross?.amount ? val.price_gross?.amount : 0),
		0
	);

	const netSummary = summaryTaxes.reduce((acc, val) => acc + (val.price_net?.amount ? val.price_net?.amount : 0), 0);

	return (
		<tbody>
			{summaryTaxes.map((tax, index) => (
				<tr key={`tax-row-${index}`}>
					<td>{FormatMoney({ ...tax.price_net, currency })}</td>
					<td>{tax.name ?? tax.tax_amount}</td>
					<td>{FormatMoney({ ...tax.price_tax, currency })}</td>
					<td className="text-end" colSpan={2}>
						{FormatMoney({ ...tax.price_gross, currency })}
					</td>
				</tr>
			))}
			<tr className="no-padding-bottom">
				<td colSpan={5} className="text-start">
					<strong>{t("modules.order.field.all.title")}:</strong>
				</td>
			</tr>
			<tr className="no-padding-top">
				<td colSpan={2}>
					<strong>{FormatMoney({ amount: netSummary, currency })}</strong>
				</td>
				<td>
					<strong>{FormatMoney({ amount: taxesSummary, currency })}</strong>
				</td>
				<td colSpan={2}>
					<strong>{FormatMoney({ amount: grossSummary, currency })}</strong>
				</td>
			</tr>
		</tbody>
	);
};

export default OrderFormItemsSummaryTableBody;
